import Banner from '../components/sections/Banner';
import AboutSection from '../components/sections/AboutSection';
import ApproachSection from '../components/sections/ApproachSection';
import ArchivesSection from '../components/sections/ArchivesSection';
import PartnersSection from '../components/sections/PartnersSection';
import NumbersSection from '../components/sections/NumbersSection';
import TestimonialSection from '../components/sections/TestimonialSection';
import GallerySection from '../components/sections/GallerySection';
import BlogSection from '../components/sections/BlogSection';

const Home = () => {
  return (
    <div className="index-one">
      <Banner />
      <AboutSection />
      <ApproachSection />
      <ArchivesSection />
      <PartnersSection />
      <NumbersSection />
      <TestimonialSection />
      <GallerySection />
      <BlogSection />
    </div>
  );
};

export default Home;
